module.exports = __webpack_public_path__ + "img/contract-flow.15d7af7.png";